import { motion } from "framer-motion";

interface OrderCancelConfirmModalProps {
  open: boolean;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

const OrderCancelConfirmModal: React.FC<OrderCancelConfirmModalProps> = ({
  open,
  title = "Are you sure?",
  description = "This action cannot be undone.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
  
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center p-4 backdrop-blur-sm"
      onClick={onCancel}
    >
      <motion.div
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        className="bg-white rounded-xl max-w-sm w-full shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-4">
          <h3 className="text-sm font-semibold text-slate-800 mb-2">{title}</h3>

          <p className="text-xs text-slate-500 mb-4">{description}</p>

          <div className="flex gap-2">
            <button
              onClick={onCancel}
              disabled={loading}
              className="flex-1 bg-slate-200 text-slate-600 py-1.5 rounded-md text-xs hover:bg-slate-300 transition disabled:opacity-50"
            >
              {cancelText}
            </button>

            <button
              onClick={onConfirm}
              disabled={loading}
              className="flex-1 bg-red-500 text-white py-1.5 rounded-md text-xs hover:bg-red-600 transition disabled:opacity-50"
            >
              {loading ? "Processing..." : confirmText}
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default OrderCancelConfirmModal;
